module.exports = __webpack_public_path__ + "static/media/eye-watermark-light.01cc1113.svg";